import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {resetOfflineCacheLegacyFrameAction} from '../../../../../components/legacy/legacyFrameActions';
import {useAppDispatch} from '../../../../../helpers/reduxHelpers';

/*
 * Props.
 */

/*
 * Component.
 */

export const ClearOfflineCacheButton: FC = (props) => {
  const dispatch = useAppDispatch();
  const [hasClicked, setHasClicked] = useState(false);

  return (
    <Button
      variant={ButtonVariantsEnum.SECONDARY}
      size={VisualSizesEnum.MEDIUM}
      isDisabled={hasClicked}
      onClick={() => {
        dispatch(resetOfflineCacheLegacyFrameAction());
        setHasClicked(true);
      }}
    >
      <Trans id="clear-offline-cache-button">Clear offline cache</Trans>
    </Button>
  );
};
